import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({
        business_name: "Cake Central",
        tagline: "Bespoke cakes for life's sweetest moments",
        about_short: "",
        about_long: "",
        address: "Sydney, NSW",
        email: "info@cakecentral.com.au",
        phone: "0410 477 455",
        whatsapp: "0410 477 455",
        instagram_url: "https://instagram.com/cakecentral",
        facebook_url: "https://facebook.com/cakecentral",
        tiktok_url: "",
        youtube_url: "",
    });

    useEffect(() => {
        api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
}

export const useSettings = () => useContext(SettingsContext);
